<mat-chip-set>
  <div class="chip-wrapper flex w-100 wrap">
    <ng-container *ngFor="let item of items">
      <mat-chip-row class="flex align-center justify-center" *ngIf="item?.value" (removed)="removeItem(item)">
        <span class="text-primary pr-1 brd-r brd-primary-light"> {{item.value}} </span>
        <button class="p-1" matChipRemove>
          <app-icon name="cross" size="xxs"></app-icon>
        </button>
      </mat-chip-row>
    </ng-container>
  </div>
</mat-chip-set>

